<template>
  <!-- 外层容器 -->
  <div class="w-full h-auto py-[3.75vw] bg-[#FFFFFF]">
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[3.75vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          课外课程体系-<span class="text-[#F28334] font-bold">周末班</span>
        </div>
      </div>
    </div>

    <!-- 容器区域 -->
    <div
      class="relative w-[61.46vw] h-auto left-1/2 -translate-x-1/2 flex flex-col justify-center mb-[3.22vw] gap-[5.26vw]"
    >
      <!-- 内容容器1 -->
      <div class="w-full flex flex-row items-center gap-[3.33vw]">
        <!-- 段落内容 -->
        <div
          class="relative flex-1 h-auto flex flex-col justify-center gap-[0.53vw]"
        >
          <!-- 主标题框 -->
          <div class="h-auto flex justify-start items-center">
            <div
              class="text-[1.46vw] text-[#1A2233] font-harmony font-bold text-start"
            >
              启蒙探索班
            </div>
          </div>
          <!-- 段落内容 -->
          <div class="h-auto flex flex-col justify-center items-center">
            <div class="text-start font-harmony">
              <p
                class="text-[0.73vw] text-[#676B73] font-normal"
                style="text-align: justify; text-justify: inter-ideograph"
              >
                以趣味性与体验性为导向，引领学生初步踏入航空无人机领域。课程通过理论知识的趣味讲解、多样化的模型制作实操以及循序渐进的实飞训练，构建起学生对航空领域的初步认知体系。
              </p>
            </div>
          </div>
          <!-- 子内容 -->
          <div
            class="relative flex-1 h-auto my-[0.83vw] flex flex-col justify-center gap-[0.83vw]"
          >
            <!-- 亮点容器 -->
            <div class="flex items-start gap-[0.52vw]">
              <i
                class="el-icon-s-opportunity text-[1.08vw] text-[#F86C26] mt-[0.3vw]"
              ></i>
              <!-- 亮点内容 -->
              <div class="h-auto flex flex-col justify-center items-center">
                <div class="text-start font-harmony">
                  <div
                    class="text-[1.04vw] text-[#1A2233] font-harmony font-normal"
                  >
                    亮点
                  </div>
                  <p
                    class="text-[0.73vw] text-[#9CA3AF] font-normal"
                    style="text-align: justify; text-justify: inter-ideograph"
                  >
                    课程内容围绕全国青少年无人机大赛和飞北无人机障碍赛等，让学生提前熟悉比赛规则和赛道，为参加比赛做好准备
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- 标签容器 -->
          <div
            class="w-[9.69vw] py-[0.26vw] bg-[#05358c] outline-[0.22vw] shadow-[0vw_0.2vw_0.2vw_0vw_rgba(0,0,0,0.15)] rounded inline-flex justify-center items-center"
          >
            <div
              class="text-center justify-start text-[#FFFFFF] text-[0.75vw] font-normal font-harmony"
            >
              适合群体：零基础学员
            </div>
          </div>
        </div>
        <!-- 图片容器 -->
        <div
          class="w-[29.22vw] h-[15.16vw] my-auto flex items-center flex-shrink-0"
        >
          <el-image
            class="w-full h-full object-center object-cover rounded-l"
            :src="`https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/courseSystem/module3/image1.png`"
            lazy
          />
        </div>
      </div>
      <!-- 内容容器2 -->
      <div class="w-full flex flex-row items-center gap-[3.33vw]">
        <!-- 图片容器 -->
        <div
          class="w-[29.22vw] h-[15.16vw] my-auto flex items-center flex-shrink-0"
        >
        <el-image
            class="w-full h-full object-center object-cover rounded-l"
            :src="`https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/courseSystem/module3/image2.png`"
            lazy
          />
        </div>
        <!-- 段落内容 -->
        <div
          class="relative flex-1 h-auto flex flex-col justify-center gap-[0.53vw]"
        >
          <!-- 主标题框 -->
          <div class="h-auto flex justify-start items-center">
            <div
              class="text-[1.46vw] text-[#1A2233] font-harmony font-bold text-start"
            >
              进阶成长班
            </div>
          </div>
          <!-- 段落内容 -->
          <div class="h-auto flex flex-col justify-center items-center">
            <div class="text-start font-harmony">
              <p
                class="text-[0.73vw] text-[#676B73] font-normal"
                style="text-align: justify; text-justify: inter-ideograph"
              >
                进阶成长阶段课程在启蒙探索的基础上，聚焦于提升学生在航空领域的综合能力，尤其是团队协作与竞赛实战能力。围绕无人机团体接力竞速和定点抛投等竞赛项目，帮助学生深入掌握竞赛技巧，提升团队协作水平。
              </p>
            </div>
          </div>
          <!-- 子内容 -->
          <div
            class="relative flex-1 h-auto my-[0.83vw] flex flex-col justify-center gap-[0.83vw]"
          >
            <!-- 亮点容器 -->
            <div class="flex items-start gap-[0.52vw]">
              <i
                class="el-icon-s-opportunity text-[1.08vw] text-[#F86C26] mt-[0.3vw]"
              ></i>
              <!-- 亮点内容 -->
              <div class="h-auto flex flex-col justify-center items-center">
                <div class="text-start font-harmony">
                  <div
                    class="text-[1.04vw] text-[#1A2233] font-harmony font-normal"
                  >
                    亮点
                  </div>
                  <p
                    class="text-[0.73vw] text-[#9CA3AF] font-normal"
                    style="text-align: justify; text-justify: inter-ideograph"
                  >
                    定点抛投项目 + 团体接力竞速项目
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- 标签容器 -->
          <div
            class="w-[9.69vw] py-[0.26vw] bg-[#05358c] outline-[0.22vw] shadow-[0vw_0.2vw_0.2vw_0vw_rgba(0,0,0,0.15)] rounded inline-flex justify-center items-center"
          >
            <div
              class="text-center justify-start text-[#FFFFFF] text-[0.75vw] font-normal font-harmony"
            >
              适合群体：有基础学员
            </div>
          </div>
        </div>
      </div>
      <!-- 内容容器3 -->
      <div class="w-full flex flex-row items-center gap-[3.33vw]">
        <!-- 段落内容 -->
        <div
          class="relative flex-1 h-auto flex flex-col justify-center gap-[0.53vw]"
        >
          <!-- 主标题框 -->
          <div class="h-auto flex justify-start items-center">
            <div
              class="text-[1.46vw] text-[#1A2233] font-harmony font-bold text-start"
            >
              专业领航班
            </div>
          </div>
          <!-- 段落内容 -->
          <div class="h-auto flex flex-col justify-center items-center">
            <div class="text-start font-harmony">
              <p
                class="text-[0.73vw] text-[#676B73] font-normal"
                style="text-align: justify; text-justify: inter-ideograph"
              >
                课程以固定翼航模为核心学习对象，构建了一套从基础到进阶、从模拟到真机、从常规操作到特技表演的系统教学体系。理论课程深入讲解航空专业知识，涵盖空气动力学、飞行力学、航空气象学等多个领域，为学生的实践操作提供坚实的理论支撑。
              </p>
            </div>
          </div>
          <!-- 子内容 -->
          <div
            class="relative flex-1 h-auto my-[0.83vw] flex flex-col justify-center gap-[0.83vw]"
          >
            <!-- 亮点容器 -->
            <div class="flex items-start gap-[0.52vw]">
              <i
                class="el-icon-s-opportunity text-[1.08vw] text-[#F86C26] mt-[0.3vw]"
              ></i>
              <!-- 亮点内容 -->
              <div class="h-auto flex flex-col justify-center items-center">
                <div class="text-start font-harmony">
                  <div
                    class="text-[1.04vw] text-[#1A2233] font-harmony font-normal"
                  >
                    亮点
                  </div>
                  <p
                    class="text-[0.73vw] text-[#9CA3AF] font-normal"
                    style="text-align: justify; text-justify: inter-ideograph"
                  >
                    无人机特技表演－悬挂彩带飞行、360°旋转飞行
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- 标签容器 -->
          <div
            class="w-[9.69vw] py-[0.26vw] bg-[#05358c] outline-[0.22vw] shadow-[0vw_0.2vw_0.2vw_0vw_rgba(0,0,0,0.15)] rounded inline-flex justify-center items-center"
          >
            <div
              class="text-center justify-start text-[#FFFFFF] text-[0.75vw] font-normal font-harmony"
            >
              适合群体：竞赛方向学员
            </div>
          </div>
        </div>
        <!-- 图片容器 -->
        <div
          class="w-[29.22vw] h-[15.16vw] my-auto flex items-center flex-shrink-0"
        >
        <el-image
            class="w-full h-full object-center object-cover rounded-l"
            :src="`https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/courseSystem/module3/image3.png`"
            lazy
          />
        </div>
      </div>
    </div>
    <!-- 按钮容器 -->
    <el-button
      native-type="submit"
      class="flex mx-auto justify-center items-center custom-button"
      @mouseenter="hoverButton = true"
      @mouseleave="hoverButton = false"
      @click="smoothScrollToBottom"
    >
      免费试听
    </el-button>
  </div>
</template>

<script>
export default {
  name: "coursesystem-module3",
  data() {
    return {};
  },
  methods: {
    // 平滑滚动到底部
    smoothScrollToBottom() {
      const targetScroll = document.documentElement.scrollHeight;
      const startPosition = window.scrollY || window.pageYOffset;
      const distance = targetScroll - startPosition;
      let startTime = null;

      function animation(currentTime) {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = easeInOutQuad(timeElapsed, startPosition, distance, 1000);
        window.scrollTo(0, run);
        if (timeElapsed < 1000) requestAnimationFrame(animation);
      }

      function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      }

      requestAnimationFrame(animation);
    },
  },
};
</script>

<style scoped>
/* 自定义按钮样式 */
.custom-button {
  width: 6.87vw;
  height: 2.92vw;
  background: #f28334 !important;
  border: none;
  border-radius: 0.25vw;
  transition: all 0.3s;
}

.custom-button :deep(span) {
  color: white;
  font-size: 1.04vw;
  font-weight: bold;
  font-family: "HarmonyOS Sans SC";
}

.custom-button:hover {
  transform: scale(1.05);
  box-shadow: 0 0.2vw 0.6vw rgba(242, 131, 52, 0.5);
}
</style>